import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { useForm } from 'antd/es/form/Form';

import { StepFiveFormContext } from './StepFiveFormContext';

import { CreditCardsInsured } from '../../../../../../../../../../../shared/interfaces';
import { TransferRightsFormData } from '../../../../../../../../../../../shared/interfaces/services/transfer-rights-service';

export interface ClientDataSectionForm {
  address: string;
  contractDate: any;
  cuit: number;
  documentNumber: number;
  documentType: number;
  fullName: string;
  genderType: number;
  inscriptionDate: any;
  inscriptionNumber: string;
  ivaCondition: number;
  location: string;
  nationality: number;
  perceptionAgent: string;
  personType: string;
  province: string;
  societyType: number;
}

export interface AdditionalDataSectionForm {
  addressEmail: string;
  birthDate: string;
  cellphoneNumber: string;
  civilStatus: number;
  countryBirth: number;
  cuilNumber: number;
  economicActivity: number;
  placeOfBirth: string;
  profession: number;
  rutaNumber: number;
  telephoneNumber: string;
  telephoneNumberJob: string;
  webPage: string;
}

export interface PaymentMethodSectionForm {
  cardNumber: number;
  cbuNumber: number;
  companyCreditCard: number;
  expiration: string;
  paymentMethod: string;
}

export const StepFiveFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const [additionalDataSectionForm] = useForm<AdditionalDataSectionForm>();
  const [clientDataSectionForm] = useForm<ClientDataSectionForm>();
  const [paymentMethodSectionForm] = useForm<PaymentMethodSectionForm>();
  const [propertyDataForm] = useForm();

  const [validitySectionForm] = useForm<{ validityDate: any }>();
  const [additionalDataFormValues, setAdditionalDataFormValues] =
    useState<AdditionalDataSectionForm>();
  const [clientDataFormValues, setClientDataFormValues] =
    useState<ClientDataSectionForm>();
  const [errorCreditCardMessage, setErrorCreditCardMessage] =
    useState<string>('');

  const [isUploadForm, setIsUploadForm] = useState<boolean>(false);
  const [listCreditCardInsured, setListCreditCardInsured] =
    useState<CreditCardsInsured>();
  const [methodSelectedFromStepThree, setMethodSelectedFromStepThree] =
    useState<any>();

  const [paymentMethodFormValues, setPaymentMethodFormValues] =
    useState<PaymentMethodSectionForm>();

  const [contactDataForm] = useForm();

  const [transferRightsList, setTransferRightsList] = useState<TransferRightsFormData[]>([]);

  const values = useMemo(
    () => ({
      additionalDataFormValues,
      additionalDataSectionForm,
      clientDataFormValues,
      clientDataSectionForm,
      contactDataForm,
      errorCreditCardMessage,
      isUploadForm,
      listCreditCardInsured,
      methodSelectedFromStepThree,
      paymentMethodFormValues,
      paymentMethodSectionForm,
      propertyDataForm,
      setAdditionalDataFormValues,
      setClientDataFormValues,
      setErrorCreditCardMessage,
      setIsUploadForm,
      setListCreditCardInsured,
      setMethodSelectedFromStepThree,
      setPaymentMethodFormValues,
      setTransferRightsList,
      transferRightsList,
      validitySectionForm,
    }),
    [
      additionalDataFormValues,
      additionalDataSectionForm,
      clientDataFormValues,
      clientDataSectionForm,
      contactDataForm,
      errorCreditCardMessage,
      isUploadForm,
      listCreditCardInsured,
      methodSelectedFromStepThree,
      paymentMethodFormValues,
      paymentMethodSectionForm,
      propertyDataForm,
      setAdditionalDataFormValues,
      setClientDataFormValues,
      setErrorCreditCardMessage,
      setIsUploadForm,
      setListCreditCardInsured,
      setMethodSelectedFromStepThree,
      setPaymentMethodFormValues,
      setTransferRightsList,
      transferRightsList,
      validitySectionForm,
    ]
  );

  return (
    <StepFiveFormContext.Provider value={values}>
      {children}
    </StepFiveFormContext.Provider>
  );
};
